// removed by extract-text-webpack-plugin
module.exports = {"OrderNotes":"_27h0D","subtext":"_2gmUN","forgotPasswordButton":"_3jvPQ","error":"d4ixS","input":"_1rQse","invalid":"_1Prpt","noteInput":"cq7m4 _1rQse","inputInvalid":"_2Wnv2","poweredBy":"_29Q2N"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Checkout/OrderNotes/index.sass
// module id = 1467
// module chunks = 1